// extracted by mini-css-extract-plugin
export default {"promise":"promise_promise__M6NYR"};